// TODO: [PRO-3634] `displayContent` convention for localization. Turn text to translate into a localization en-US.json
export const displayContent = {
  emptyText: 'We’ll generate a blank campaign for you if you skip this.',
  changeText: 'Replace template',
  chooseText: 'Choose a template',
};

export const TEMPLATE_PREVIEW_AURORA_ID = 'template-preview-aurora';
